import { createSelector } from 'reselect'

export const getCartHistory = createSelector(
  (state) => state && state.cart && state.cart.history && Array.isArray(state.cart.history.items) ? state.cart.history.items : [],
  items => items
)
